import React, { useEffect, useState } from 'react';
import BillingInfoPanel from '../../components/BillingInfoPanel';
import { API_BASE } from './../../config';
import { useAuth } from './../../context/AuthContext';

const BillingTab = ({ tenantId }) => {
  const { token } = useAuth();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchBilling = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/admin/billing/${tenantId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        throw new Error(`Failed to fetch billing info: ${res.statusText}`);
      }
      const data = await res.json();
      setBilling(data);
    } catch (err) {
      setError(err.message || 'Failed to load billing information.');
      setBilling(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token && tenantId) {
      fetchBilling();
    }
  }, [token, tenantId]);

  if (loading) return <p className="loading-text">Loading billing information...</p>;
  if (error) return <p className="error-text">{error}</p>;

  return <BillingInfoPanel billing={billing} />;
};

export default BillingTab;
